var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.49918,
    cy: 4.92105,
    r: 3.92105,
    fill: "#40D9B5",
    fillOpacity: 0.5,
    stroke: "#40D9B5",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.971C1 14.9754 4.23907 11.7363 8.23465 11.7363H8.76535C12.7609 11.7363 16 14.9754 16 18.971C16 19.3065 15.728 19.5784 15.3926 19.5784H1.60745C1.27196 19.5784 1 19.3065 1 18.971Z",
    fill: "#40D9B5",
    fillOpacity: 0.5,
    stroke: "#40D9B5",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountMan);
export default __webpack_public_path__ + "static/media/account-man.5b74f7329177a3e20ad3f051c5fe316d.svg";
export { ForwardRef as ReactComponent };